import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen bg-[#0A0E27] text-white font-sans selection:bg-[#FF5722] selection:text-white" data-id="element-155">
      <Header data-id="element-156" />
      {children}
      <Footer data-id="element-157" />
    </div>;
}